import { DeviceTypes } from '@/typings/enums/enums';
import {
  FlowRegistrationInfo,
  GameData,
  GameSectionImageOverlay,
  GlobalState,
  InstantWinData,
  MetricData,
  ReplacementTags
} from '@/store/modules/global/state';
import { GetterTree } from 'vuex';
import { RootState } from '@/store/state';
import { AddonEditItem } from '@/typings/interfaces/data/campaign';

export type Getters<S = GlobalState> = {
  getGameData(state: S): GameData | null;
  getInstantWinData(state: S): InstantWinData | null;
  isGameWinner(state: S): boolean | null;
  getMetricData(state: S): MetricData;
  currentDevice(state: S): DeviceTypes | undefined;
  addonsData(state: S): Record<string, AddonEditItem>;
  replacementTags(state: S): ReplacementTags;
  initializationTime(state: S): number | undefined;
  state(state: S): GlobalState;
  staticFormData(state: S): Record<string, string>;
  flowRegistrationInfo(state: S): FlowRegistrationInfo | undefined;
  gameSectionImageOverlay(state: S): GameSectionImageOverlay | undefined;
  gameTestDate(state: S): Date | undefined;
};

export interface NamespacedGetters {
  'global/getGameData': GameData | null;
  'global/getInstantWinData': InstantWinData | null;
  'global/isGameWinner': boolean | null;
  'global/getMetricData': MetricData;
  'global/currentDevice': DeviceTypes | undefined;
  'global/addonsData': Record<string, AddonEditItem>;
  'global/replacementTags': ReplacementTags;
  'global/initializationTime': number | undefined;
  'global/state': GlobalState;
  'global/staticFormData': Record<string, string>;
  'global/flowRegistrationInfo': FlowRegistrationInfo | undefined;
  'global/gameSectionImageOverlay': GameSectionImageOverlay | undefined;
  'global/gameTestDate': Date;
}

export const getters: GetterTree<GlobalState, RootState> & Getters = {
  getGameData: (state) => {
    return state.gameData;
  },
  isGameWinner: (state) => {
    return state.gameWinner;
  },
  getMetricData: (state) => {
    return state.metricData ?? {};
  },
  getInstantWinData: (state) => {
    return state.instantWinData;
  },
  currentDevice: (state) => {
    return state.currentDevice ?? undefined;
  },
  addonsData: (state) => {
    if (state.addonsData) {
      return state.addonsData;
    }
    return {};
  },
  replacementTags: (state) => {
    return state.replacementTags;
  },
  initializationTime: (state) => {
    return state.initializationTime;
  },
  state: (state) => {
    return state;
  },
  staticFormData: (state) => {
    return state.staticFormData;
  },
  flowRegistrationInfo: (state) => {
    return state.flowRegistrationInfo;
  },
  gameSectionImageOverlay: (state) => {
    return state.gameSectionImageOverlay;
  },
  gameTestDate: (state) => {
    return state.gameTestDate;
  }
};
